/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the Note HTTP resource (factory product). */
export class NoteResource {
}

export function createNoteResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const NoteResource = createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'notes',
    () => localUserProfile
  );
  const parentQuery = NoteResource.query;

  NoteResource.create = function(defaults: any) {
    return new NoteResource(_.assign({
      dataType: 'HTML'
    }, defaults));
  };

  NoteResource.query = function(ids: any, a1: any, a2: any) {
    return parentQuery({ids: ids, orderBy: 'createTime'}, a1, a2);
  };

  return NoteResource;
}

export const noteResourceProvider = {
  provide: NoteResource,
  useFactory: createNoteResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

